import { queryGraphQL } from 'common/util/query';
import { nodeWithArgs, toQuery, toMutation } from 'common/util/queryHelper';
import { get, map } from 'lodash';
import { addApplicationMessages, addApplicationMessage } from 'common/actions/applicationMessagesActions';
export const ACTIONS = {
    USER_BINDERS_LOADING: 'USER_BINDERS_LOADING',
    USER_BINDERS_LOAD: 'USER_BINDERS_LOAD',
    USER_BINDERS_LOADED: 'USER_BINDERS_LOADED',
    USER_BINDERS_RESET: 'USER_BINDERS_RESET',
    USER_BINDERS_SELECTED: 'USER_BINDERS_SELECTED',
    ADD_USER_TO_BINDERS: 'ADD_USER_TO_BINDERS',
    ADD_USER_TO_BINDERS_REQUEST: 'ADD_USER_TO_BINDERS_REQUEST',
    ADD_USER_TO_BINDERS_SUCCESS: 'ADD_USER_TO_BINDERS_SUCCESS',
    ADD_USER_TO_BINDERS_FAILURE: 'ADD_USER_TO_BINDERS_FAILURE',
    USER_BINDERS_MODAL_SHOW: 'USER_BINDERS_MODAL_SHOW',
    USER_BINDERS_ROW_CHECKED: 'USER_BINDERS_ROW_CHECKED'
};

export function loadUserBinders(institutionId, userId) {
    return async dispatch => {
        dispatch(loadingUserBinders());
        const userBindersNode = nodeWithArgs('getUserBinders', {
            userId,
            institutionId,
        }, [
            'id',
            'name',
            'principalInvestigator',
            'site'
        ]);
        const response = await queryGraphQL(toQuery(userBindersNode));
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch(loadedUserBinders());
            return;
        }
        dispatch({
            type: ACTIONS.USER_BINDERS_LOAD,
            payload: {
                data: get(response, 'data.getUserBinders', []),
            }
        });
    };
}

export function loadingUserBinders() {
    return { type: ACTIONS.USER_BINDERS_LOADING };
}

export function loadedUserBinders() {
    return { type: ACTIONS.USER_BINDERS_LOADED };
}

export function resetUserBinders() {
    return {
        type: ACTIONS.USER_BINDERS_RESET,
        payload: {
            isLoading: false,
            error: { isPresent: false, message: null }
        }
    };
}

export function addUserToBinders(institutionId, userId, binderIds) {
    return async dispatch => {
        dispatch(addUserToBindersRequest());
        const mutation = toMutation(
            nodeWithArgs('addUserToBinders', {
                institutionId,
                userId,
                binderIds
            },[
                'id',
                'name',
                'principalInvestigator',
                'site'
            ])
        );
        const response = await queryGraphQL(mutation);
        if (response.errors) {
            dispatch(addApplicationMessages('error', map(response.errors, 'message')));
            dispatch(addUserToBindersFailure(response.errors));
            return;
        }
        dispatch({
            type: ACTIONS.ADD_USER_TO_BINDERS,
            payload: {
                data: get(response, 'data.addUserToBinders', []),
            }
        });
        dispatch(addApplicationMessage('success', 'Bulk adding user to binders succeeded'));
    };
}

export function addUserToBindersRequest() {
    return {
        type: ACTIONS.ADD_USER_TO_BINDERS_REQUEST,
    };
}

export function addUserToBindersSuccess(responseData) {
    return {
        type: ACTIONS.ADD_USER_TO_BINDERS_SUCCESS,
        payload: {
            user: responseData,
        }
    };
}

export function addUserToBindersFailure(error) {
    return {
        type: ACTIONS.ADD_USER_TO_BINDERS_FAILURE,
        payload: {
            error: error
        }
    };
}

export function setSelectedBinders(selectedBinderIds) {
    return {
        type: ACTIONS.USER_BINDERS_SELECTED,
        payload: {
            selectedBinderIds
        }
    };
}

export function setRowChecked(data) {
    return {
        type: ACTIONS.USER_BINDERS_ROW_CHECKED,
        payload: {
            data
        }
    };
}

export function setShowModal(show) {
    return {
        type: ACTIONS.USER_BINDERS_MODAL_SHOW,
        payload: {
            show
        }
    };
}
